/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Injectable, Inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot, CanActivate } from '@angular/router';
import { AuthService } from 'app/core/security/auth/auth.service';
import { UsersService } from 'app/modules/configuration/users/user-management/services/users.service';
import { CookieService } from 'app/shared/services/cookie.service';
import { SystemRole } from 'app/shared/enumeration/system-role';

@Injectable({providedIn: 'root'})
export class UserPermissionGuardService implements CanActivate {
  constructor(
    protected usersService: UsersService,
    protected auth: AuthService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected cookieService: CookieService
  ) {}

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let canActivate = false;
    let redirect = 'login';
    if (route.data.redirect) {
      redirect = route.data.redirect;
    }

    // Check permissions over roles so that permissions can be kept in one place - the usersService
    if (route.data.permission) {
      canActivate = await this.usersService.hasPermission(route.data.permission);
    } else if (!route.data.roles || route.data.roles.length === 0) {
      canActivate = false;
    } else {
      canActivate = await this.checkRoles(route.data.roles);
    }

    if (!canActivate && redirect !== '') {
      this.router.navigate([redirect]);
    }

    return Promise.resolve(canActivate);
  }

  protected async checkRoles(allowedRoles: SystemRole[]): Promise<boolean> {
    let isInRole = false;
    await this.usersService.getUserRoles().then((userRoles: SystemRole[]) => {
      const intersect = allowedRoles.filter(value => -1 !== userRoles.indexOf(value));
      isInRole = intersect.length > 0;
    });

    return Promise.resolve(isInRole);
  }
}
